
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Loader2 } from 'lucide-react';

interface DeleteProcurementDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isDeleting: boolean;
  procurementId: string;
}

const DeleteProcurementDialog: React.FC<DeleteProcurementDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  isDeleting,
  procurementId
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Procurement</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this procurement? This action cannot be undone.
            <br />
            <br />
            <strong>Procurement ID:</strong> {procurementId.substring(0, 8)}...
            <br />
            <br />
            This will permanently delete the procurement and all associated data including:
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Procurement items</li>
              <li>Cost breakdown</li>
              <li>Finance records</li>
              <li>Warehouse records</li>
              <li>Audit trail</li>
            </ul>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              'Delete Procurement'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteProcurementDialog;
